export const mockAudioUrls = [
  { key: "Q", path: "src/assets/easterAssets/audio/0_Q.wav" },
  { key: "W", path: "src/assets/easterAssets/audio/1_W.wav" },
  { key: "E", path: "src/assets/easterAssets/audio/2_E.wav" },
  {
    key: "R",
    path: "src/assets/easterAssets/audio/3_R.wav",
  },
  {
    key: "T",
    path: "src/assets/easterAssets/audio/4_T.wav",
  },
  {
    key: "Y",
    path: "src/assets/easterAssets/audio/5_Y.wav",
  },
  { key: "U", path: "src/assets/easterAssets/audio/6_U.wav" },
  { key: "I", path: "src/assets/easterAssets/audio/7_I.wav" },
  { key: "O", path: "src/assets/easterAssets/audio/8_O.wav" },
  { key: "P", path: "src/assets/easterAssets/audio/9_P.wav" },
  { key: "A", path: "src/assets/easterAssets/audio/10_A.wav" },
  { key: "S", path: "src/assets/easterAssets/audio/11_S.wav" },
  {
    key: "D",
    path: "src/assets/easterAssets/audio/12_D.wav",
  },
  {
    key: "F",
    path: "src/assets/easterAssets/audio/13_F.wav",
  },
  {
    key: "G",
    path: "src/assets/easterAssets/audio/14_G.wav",
  },
  {
    key: "H",
    path: "src/assets/easterAssets/audio/15_H.wav",
  },
  { key: "J", path: "src/assets/easterAssets/audio/16_J.wav" },
  {
    key: "K",
    path: "src/assets/easterAssets/audio/17_K.wav",
  },
  { key: "L", path: "src/assets/easterAssets/audio/18_L.wav" },
  { key: "Z", path: "src/assets/easterAssets/audio/19_Z.wav" },
  { key: "X", path: "src/assets/easterAssets/audio/20_X.wav" },
  { key: "C", path: "src/assets/easterAssets/audio/21_C.wav" },
  {
    key: "V",
    path: "src/assets/easterAssets/audio/22_V.wav",
  },
  {
    key: "B",
    path: "src/assets/easterAssets/audio/23_B.wav",
  },
  { key: "N", path: "src/assets/easterAssets/audio/24_N.wav" },
  {
    key: "M",
    path: "src/assets/easterAssets/audio/25_M.wav",
  },
];
